"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _LayoutPagingTable = _interopRequireDefault(require("01_core/components/layout/LayoutPagingTable"));
var _ListIconButton = _interopRequireDefault(require("01_core/components/materials/ListIconButton"));
var _SortUpdate = _interopRequireDefault(require("01_core/components/select/SortUpdate"));
var _labelConsts = require("01_core/constants/labelConsts");
var _stringConsts = require("01_core/constants/stringConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _siteOrderingActions = require("../siteOrderingActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 拠点表示順設定検索結果コンポーネント
 */
const SiteOrderingSearchResult = function (props) {
  const {
    intl,
    searchResult,
    paging,
    changeCurrentPage,
    changeViewNum,
    scrollTop,
    onScroll,
    search,
    onDetailClick,
    onSortUpdate,
    onUpdateClick
  } = props;
  const createRow = data => {
    // 並び替え用の配列を作成する
    let sortItems = [];
    data.siteSortOrders.forEach(function (siteSortOrderInfo) {
      let siteNm = _stringConsts.STRING_CONSTS.EMPTY;
      if (siteSortOrderInfo.buildingNm !== null && siteSortOrderInfo.buildingNm !== _stringConsts.STRING_CONSTS.EMPTY) {
        if (siteNm.length !== 0) {
          siteNm = siteNm + _stringConsts.STRING_CONSTS.HALF_SPACE; // 空白スペースを末尾に追加
        }
        siteNm = siteNm + siteSortOrderInfo.buildingNm; // 建物名を追加
      }
      if (siteSortOrderInfo.siteNm !== null && siteSortOrderInfo.siteNm !== _stringConsts.STRING_CONSTS.EMPTY) {
        if (siteNm.length !== 0) {
          siteNm = siteNm + _stringConsts.STRING_CONSTS.HALF_SPACE; // 空白スペースを末尾に追加
        }
        siteNm = siteNm + siteSortOrderInfo.siteNm; // 拠点名を追加
      }
      let addItem = {
        value: siteSortOrderInfo.siteNo,
        //並べ替え対象の値
        displayName: siteNm // 並べ替え対象の表示名
      };
      sortItems.push(addItem);
    });
    const actions = [data.siteCount >= 1 ? /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
      action: "detail",
      onClick: onDetailClick(data.kaishaCd, data.areaCd)
    }) : '', data.siteCount >= 2 ? /*#__PURE__*/_react.default.createElement("div", {
      onClick: onUpdateClick(data.kaishaCd, data.areaCd)
    }, /*#__PURE__*/_react.default.createElement(_SortUpdate.default, {
      items: sortItems,
      onChange: onSortUpdate,
      noUpdate: false,
      isDispListIcon: true
    })) : /*#__PURE__*/_react.default.createElement("canvas", {
      width: "39",
      height: "26"
    })];
    const kaishaNm = _stringUtil.default.emptyToHyphen(data.kaishaNm);
    const areaNm = _stringUtil.default.emptyToHyphen(data.areaNm);
    const siteCount = data.siteCount;
    return {
      actions,
      kaishaNm,
      areaNm,
      siteCount
    };
  };

  // 検索結果ヘッダ
  let listButtonLabel = [intl.formatMessage({
    id: _labelConsts.LABEL.CORE_DETAIL
  }), intl.formatMessage({
    id: _labelConsts.LABEL.CORE_UPDATE
  })];
  const columns = [{
    dataKey: 'actions',
    label: listButtonLabel,
    direction: 'row'
  }, {
    dataKey: 'kaishaNm',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_COMPANY_NAME
    }),
    width: 300
  }, {
    dataKey: 'areaNm',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.MASTERDATA_AREA_NM
    }),
    width: 300
  }, {
    dataKey: 'siteCount',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.MASTERDATA_SITE_COUNT
    }),
    width: 300
  }];
  return /*#__PURE__*/_react.default.createElement(_LayoutPagingTable.default, {
    title: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_SEARCH_RESULT_LIST
    }),
    rowData: searchResult,
    createRow,
    columns,
    paging,
    changeCurrentPage,
    changeViewNum,
    scrollTop,
    onScroll,
    reload: search,
    putTypography: true
  });
};
const mapStateToProps = state => {
  return {
    searchResult: state.siteOrdering.searchResult,
    paging: state.siteOrdering.paging,
    scrollTop: state.siteOrdering.scrollTop,
    search: state.siteOrdering.search
  };
};
const mapDispatchToProps = dispatch => {
  return {
    changeCurrentPage: currentPage => dispatch(_siteOrderingActions.siteOrderingActions[_siteOrderingActions.TYPES.CHANGE_PAGE](currentPage)),
    changeViewNum: viewNum => dispatch(_siteOrderingActions.siteOrderingActions[_siteOrderingActions.TYPES.CHANGE_VIEW_NUM](viewNum)),
    onScroll: scrollTop => dispatch(_siteOrderingActions.siteOrderingActions[_siteOrderingActions.TYPES.CHANGE_SCROLL_TOP](scrollTop))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(SiteOrderingSearchResult));